/**
 * Copyright 2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { ExtendedTooltip, FlexContainer, SVGIcon } from "@nordcloud/gnui";
import { getPlanInfo } from "~/views/plans/utils";

type Props = {
  enabled: boolean;
  cronExpression: string;
  scheduleExecutionDates: string[];
};

export function PlanStateIconCell({
  enabled,
  cronExpression,
  scheduleExecutionDates,
}: Props) {
  const planState = getPlanInfo(
    enabled,
    cronExpression,
    scheduleExecutionDates
  );

  return (
    <FlexContainer justifyContent="center" alignItems="center">
      <ExtendedTooltip status={planState.status} caption={planState.caption}>
        <FlexContainer justifyContent="center" alignItems="center">
          <SVGIcon
            color={planState.status}
            size="md"
            name={planState.iconName}
          />
        </FlexContainer>
      </ExtendedTooltip>
    </FlexContainer>
  );
}
